export const CANCEL = 'CANCEL'
export const AMEND = 'AMEND'
export const HAND_BAGGAGE = 'HAND_BAGGAGE'
export const CHECK_IN_BAGGAGE = 'CHECK_IN_BAGGAGE'
export const CARRY_ON = 'CARRY_ON'
export const CHECK_IN = 'CHECK_IN'
export const SEAT = 'SEAT'
export const MEAL = 'MEAL'
export const BENEFIT_NOT_INCLUDED = 'Not included'
export const VISA_REJECTION_COVER = 'VISA_REJECTION_COVER'
export const VISA_COVER_FREE_LABEL = 'Free'
export const VISA_COVER_AVAILABLE_LABEL = 'Available'
export const VISA_INFO_ICON_SIZE = '14'

export const penalitiesTitleConfig: any = {
    [AMEND]: 'Date change fee',
    [CANCEL]: 'Refund amount on cancellation'
}

export const BFF_RT_DISABLED_FARE_TOAST = {
  NON_CT_BRANDED: 'Change onward fare to continue. Value Max requires to be selected for both flights.',
  CT_BRANDED: 'Value Max requires to be selected for both flights. Change onward fare to continue',
} as const
